import { environment } from '@sprint-backoffice/environments/environment';
import { OAuthModuleConfig } from 'angular-oauth2-oidc';

export const authModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: environment.authAllowedUrls.web,
    sendAccessToken: true,
  },
};
